import React from 'react';

import LegalDocumentPage, { LegalDocumentContent } from '../LegalDocumentPage/LegalDocumentPage';
import { termsOfUse } from '../LegalDocumentPage/legalDocuments';

const TermsOfServiceContent = props =>
  Object.keys(props).length ? (
    <LegalDocumentContent document={termsOfUse} />
  ) : (
    <LegalDocumentPage document={termsOfUse} withPageChrome />
  );

const TermsOfServicePageComponent = () => <TermsOfServiceContent />;

export { TermsOfServicePageComponent, TermsOfServiceContent };

export default TermsOfServicePageComponent;
